/* Create Your Own: profile tool geometry. Fixed body from Profile-Tool_Chevron.svg; only the left edge is generated. */
(function () {
  'use strict';
  var T = window.CYO_PROFILE_TEMPLATE;
  if (!T) { console.error("CYO profile template missing"); return; }
  var N_DRAW = 64;
  /* trough = u where the edge is outermost, peak = u where it cuts deepest. Every pattern starts at a trough (meets the top corner) and ends at a peak (meets the built-in foot). */
  var PATTERNS = [
    { id: 'chevron', name: 'Chevron', trough: 0, peak: 0.5, f: function (u) { return u < 0.5 ? 2 * u : 2 - 2 * u; } },
    { id: 'wave', name: 'Wave', trough: 0, peak: 0.5, f: function (u) { return (1 - Math.cos(2 * Math.PI * u)) / 2; } },
    { id: 'scallop', name: 'Scallop', trough: 0, peak: 0.5, f: function (u) { var v = 2 * u - 1; return Math.sqrt(Math.max(0, 1 - v * v)); } },
    { id: 'bubble', name: 'Bubble', trough: 0.5, peak: 1, f: function (u) { var v = 2 * u - 1; return 1 - Math.sqrt(Math.max(0, 1 - v * v)); } },
    { id: 'sawtooth', name: 'Sawtooth', trough: 0, peak: 1, f: function (u) { return u; } },
    { id: 'castle', name: 'Castle', trough: 0, peak: 1, f: function (u) { return u < 0.5 ? 0 : 1; } },
    { id: 'straight', name: 'Straight', trough: 0, peak: 1, f: function (u) { return u >= 0.999 ? 1 : 0; } }
  ];
  /* signature edges traced from the house tools (assets/cyo-profile-edges.js) */
  (window.CYO_PROFILE_EDGES || []).forEach(function (e) {
    var s = e.s, n = s.length;
    PATTERNS.push({ id: e.id, name: e.name, sig: true, trough: 0, peak: e.peak, defDepth: e.depth, defRepeats: e.repeats,
      f: function (u) { var x = (u >= 1 ? 0.999999 : u) * n, i = Math.floor(x), fr = x - i; return s[i % n] * (1 - fr) + s[(i + 1) % n] * fr; } });
  });
  var COLORS = { 'Hot Pink': '#E8478B', 'Glitter': '#B9B4C7', 'Bright Orange': '#F26A1B', 'Teal': '#1E9FA0', 'Charcoal': '#3A3A3A' };
  var MAX_DEPTH_IN = 0.6, MIN_DEPTH_IN = 0.05;
  /* the foot ends at a set point and the edge eases to it along a 45 degree chamfer:
     standard = cut in as deep as the edge goes, up to 0.25in; reversed = flush with the straight edge */
  var FOOT_MAX_IN = 0.25;
  function footMask(pts, o) {
    var F = FOOT_MAX_IN * T.unitsPerIn, dense = [], deep = 0, w = 0;
    pts.forEach(function (p, i) { if (i) deep = Math.max(deep, p[0] - T.outerX); });
    var c = o.footRev ? 0 : Math.min(F, deep);
    for (var i = 0; i < pts.length; i++) {
      if (i > 0) { var a = pts[i - 1], b = pts[i], n = Math.ceil(Math.abs(b[1] - a[1]) / 2); for (var j = 1; j < n; j++) dense.push([a[0] + (b[0] - a[0]) * j / n, a[1] + (b[1] - a[1]) * j / n]); }
      dense.push(pts[i].slice());
    }
    /* x stays within a band around the foot point that widens by 45 degrees going up */
    return dense.map(function (p, i) { if (i === 0) return p; var m = w + Math.max(0, T.y1 - p[1]), x0 = T.outerX + c; return p[0] > x0 + m ? [x0 + m, p[1]] : p[0] < x0 - m ? [x0 - m, p[1]] : p; });
  }

  function pattern(id) { return PATTERNS.find(function (p) { return p.id === id; }) || PATTERNS[0]; }
  function defaults() { return { mode: 'pattern', pattern: 'chevron', depthIn: +(T.defaultDepth / T.unitsPerIn).toFixed(2), repeats: 6, draw: null }; }

  function sampleFn(o) {
    if (o.mode === 'draw' && o.draw && o.draw.length) {
      var a = o.draw.slice(); a[0] = 0;
      return function (t) { var x = t * (a.length - 1), i = Math.floor(x), f = x - i; return i >= a.length - 1 ? a[a.length - 1] : a[i] * (1 - f) + a[i + 1] * f; };
    }
    var p = pattern(o.pattern), k = Math.max(1, Math.round(o.repeats || 1));
    var span = k + (p.peak - p.trough);              /* whole repeats plus the run from outermost to deepest */
    return function (t) {
      var v = p.trough + t * span, u = v - Math.floor(v);
      if (t >= 1) u = p.peak >= 1 ? 1 : p.peak;      /* land exactly on the peak at the foot */
      return p.f(u);
    };
  }

  /* reversed: mirror the edge within its own depth, so notches become bumps and the tool stays the same width */
  function reverse(pts, o) {
    if (!o.reverse) return pts;
    var deep = 0; pts.forEach(function (p, i) { if (i) deep = Math.max(deep, p[0] - T.outerX); });
    return pts.map(function (p, i) { return i ? [T.outerX + deep - (p[0] - T.outerX), p[1]] : p; });
  }
  function edgePoints(o) {
    var D = Math.min(MAX_DEPTH_IN, Math.max(MIN_DEPTH_IN, o.depthIn == null ? 0.19 : o.depthIn)) * T.unitsPerIn;
    if (o.mode === 'cutouts') return footMask(reverse(cutoutPoints(o), o), o);
    var fn = sampleFn(o), steps = (o.mode === 'draw') ? 480 : (o.pattern === 'castle' || o.pattern === 'straight' || pattern(o.pattern).sig) ? 1600 : 480, pts = [];
    for (var i = 0; i <= steps; i++) {
      var t = i / steps;
      pts.push([T.outerX + D * fn(t), T.y0 + t * (T.y1 - T.y0)]);
    }
    if (o.mode !== 'draw' && o.pattern === 'straight') pts = [[T.edgeTop[0], T.y0], [T.outerX + D, T.y0 + Math.abs(D)], [T.outerX + D, T.y1]];
    pts[0][0] = T.edgeTop[0];                         /* exact join with the top corner */
    return footMask(reverse(pts, o), o);
  }

  /* ---------- cutouts: straight edge with shapes notched in ---------- */
  var CUT_SHAPES = [
    { id: 'round', name: 'Half circle', f: function (v) { return Math.sqrt(Math.max(0, 1 - v * v)); } },
    { id: 'v', name: 'V notch', f: function (v) { return Math.max(0, 1 - Math.abs(v)); } },
    { id: 'square', name: 'Square', f: function (v) { return Math.abs(v) <= 1 ? 1 : 0; } },
    { id: 'slot', name: 'Slot', f: function (v) { return Math.min(1, 3 * Math.sqrt(Math.max(0, 1 - v * v))); } },
    { id: 'dip', name: 'Soft dip', f: function (v) { return Math.abs(v) >= 1 ? 0 : (1 + Math.cos(Math.PI * v)) / 2; } }
  ];
  var CUT_MIN_W = 0.15, CUT_MAX_W = 3, CUT_MIN_D = 0.05, CUT_MAX_D = 0.5;
  function cutShape(id) { return CUT_SHAPES.find(function (c) { return c.id === id; }) || CUT_SHAPES[0]; }
  function edgeLen() { return T.y1 - T.y0; }
  function clampCut(c) {
    var w = Math.min(CUT_MAX_W, Math.max(CUT_MIN_W, c.w)), h = w * T.unitsPerIn / 2 / edgeLen();
    return { shape: c.shape, w: w, d: Math.min(CUT_MAX_D, Math.max(CUT_MIN_D, c.d)), t: Math.min(1 - h, Math.max(h, c.t)) };
  }
  function cutoutPoints(o) {
    var cuts = (o.cuts || []).map(clampCut), steps = 1600, pts = [], L = edgeLen();
    for (var i = 0; i <= steps; i++) {
      var t = i / steps, y = T.y0 + t * L, dep = 0;
      cuts.forEach(function (c) {
        var h = c.w * T.unitsPerIn / 2, v = (y - (T.y0 + c.t * L)) / h;
        if (Math.abs(v) <= 1) { var q = c.d * T.unitsPerIn * cutShape(c.shape).f(v); if (Math.abs(q) > Math.abs(dep)) dep = q; }
      });
      pts.push([T.outerX + dep, y]);
    }
    pts[0][0] = T.edgeTop[0];
    return pts;
  }
  function cutAt(o, y) {               /* index of the cutout under edge position y, or -1 */
    var L = edgeLen(), t = (y - T.y0) / L, hit = -1;
    (o.cuts || []).forEach(function (c, i) { var h = c.w * T.unitsPerIn / 2 / L; if (Math.abs(t - c.t) <= h) hit = i; });
    return hit;
  }
  function yToT(y) { return Math.min(1, Math.max(0, (y - T.y0) / edgeLen())); }

  function outlineD(o) {
    var pts = edgePoints(o), end = pts[pts.length - 1];
    /* the built-in foot runs from wherever the pattern ends down to the fixed bottom corner, so there is never a gap */
    var fixedRest = T.fixed.replace(/^M\s*[-\d.]+,[-\d.]+\s*/, '');
    var d = 'M ' + end[0].toFixed(3) + ',' + end[1].toFixed(3) + ' ' + fixedRest + ' ' +
      pts.map(function (p) { return 'L ' + p[0].toFixed(3) + ',' + p[1].toFixed(3); }).join(' ') + ' Z ' + T.hole;
    return d;
  }

  /* left edge of the drawing: 0 normally, further left when the edge pushes out past the tool body */
  function leftX(o, draw) {
    var m = 0; edgePoints(o).forEach(function (p) { m = Math.min(m, p[0]); });
    if (draw && o.depthIn < 0) m = Math.min(m, T.outerX + o.depthIn * T.unitsPerIn);
    return m < 0 ? Math.floor(m - 6) : 0;
  }
  function lum(hex) { var n = parseInt(hex.slice(1), 16); return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }

  function previewSVG(o, color, opts) {
    opts = opts || {};
    var fill = COLORS[color] || color || '#3A3A3A';
    var logoFill = lum(fill) > 0.6 ? 'rgba(0,0,0,.28)' : 'rgba(255,255,255,.4)';
    var overlay = '';
    if (opts.cutouts) {
      overlay = '<rect data-cyo-cut x="0" y="' + T.y0 + '" width="' + (T.outerX + CUT_MAX_D * T.unitsPerIn + 24) + '" height="' + (T.y1 - T.y0) + '" fill="rgba(0,0,0,.04)" style="cursor:pointer;touch-action:none"/>';
      (o.cuts || []).forEach(function (c, i) {
        var cc = clampCut(c), cy = T.y0 + cc.t * edgeLen();
        overlay += '<circle cx="' + (T.outerX - 8) + '" cy="' + cy + '" r="' + (i === o.sel ? 4.5 : 3) + '" fill="' + (i === o.sel ? '#000' : '#999') + '" pointer-events="none"/>';
      });
    }
    if (opts.draw) {
      overlay = '<rect data-cyo-draw x="' + Math.min(0, T.outerX + MIN_DEPTH_IN * T.unitsPerIn - 10) + '" y="' + T.y0 + '" width="' + (T.outerX + MAX_DEPTH_IN * T.unitsPerIn + 20 - Math.min(0, T.outerX + MIN_DEPTH_IN * T.unitsPerIn - 10)) + '" height="' + (T.y1 - T.y0) + '" fill="rgba(0,0,0,.04)" style="cursor:crosshair;touch-action:none"/>' +
        '<line x1="' + T.outerX + '" y1="' + T.y0 + '" x2="' + T.outerX + '" y2="' + T.y1 + '" stroke="#999" stroke-dasharray="3 3" stroke-width=".8" pointer-events="none"/>';
    }
    var x0 = leftX(o, opts.draw);
    return '<svg class="cyo__prof-svg" viewBox="' + x0 + ' 0 ' + (T.w - x0) + ' ' + T.h + '" role="img" aria-label="Profile tool preview">' +
      '<path data-cyo-prof-path d="' + outlineD(o) + '" fill="' + fill + '" fill-rule="evenodd"/>' +
      T.logo.map(function (d) { return '<path d="' + d + '" fill="' + logoFill + '" pointer-events="none"/>'; }).join('') +
      overlay + '</svg>';
  }

  function exportSVG(o) {
    var x0 = leftX(o, false), wIn = +(T.wIn * (T.w - x0) / T.w).toFixed(3);
    return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + wIn + 'in" height="' + T.hIn + 'in" viewBox="' + x0 + ' 0 ' + (T.w - x0) + ' ' + T.h + '">' +
      '<desc>' + label(o) + ' | depth ' + o.depthIn + ' in | ' + (o.reverse ? 'reversed' : 'normal') + ' | foot ' + (o.footRev ? 'reversed (flush)' : 'standard, max ' + FOOT_MAX_IN + ' in') + (o.mode === 'pattern' ? ' | repeats ' + o.repeats : '') + (o.mode === 'cutouts' ? ' | cutouts ' + JSON.stringify((o.cuts || []).map(clampCut)) : '') + '</desc>' +
      '<g id="engrave">' + T.logo.map(function (d) { return '<path d="' + d + '" fill="#000"/>'; }).join('') + '</g>' +
      '<path id="cut" d="' + outlineD(o) + '" fill="none" stroke="#ec1c24" stroke-width="0.72"/></svg>';
  }

  function label(o) { return o.mode === 'draw' ? 'Hand-drawn profile' : o.mode === 'cutouts' ? 'Cutout profile' : pattern(o.pattern).name + ' profile'; }

  function drawFromPattern(o) {
    var fn = sampleFn(Object.assign({}, o, { mode: 'pattern' })), a = [];
    for (var i = 0; i < N_DRAW; i++) a.push(+fn(i / (N_DRAW - 1)).toFixed(3));
    return a;
  }
  function smooth(a) {
    return a.map(function (v, i) { var p = a[i - 1] == null ? v : a[i - 1], n = a[i + 1] == null ? v : a[i + 1]; return +((p + 2 * v + n) / 4).toFixed(3); });
  }
  /* freehand guardrail: two smoothing passes remove jitter smaller than ~2 samples (~3.5 mm) so the edge cuts cleanly */
  function tidy(a) { return smooth(smooth(a)); }
  function drawAt(a, y, x, last, depthIn) {
    var D = (depthIn || MAX_DEPTH_IN) * T.unitsPerIn;
    var idx = Math.round((y - T.y0) / (T.y1 - T.y0) * (N_DRAW - 1));
    idx = Math.max(0, Math.min(N_DRAW - 1, idx));
    var val = Math.max(0, Math.min(1, (x - T.outerX) / D));
    var out = a.slice();
    if (last && last.idx !== idx) {
      var s = Math.sign(idx - last.idx);
      for (var i = last.idx; i !== idx; i += s) { var f = (i - last.idx) / (idx - last.idx); out[i] = +(last.val + (val - last.val) * f).toFixed(3); }
    }
    out[idx] = +val.toFixed(3);
    return { arr: out, idx: idx, val: val };
  }

  /* ---------- house designs (preview only; production cuts from the original file) ---------- */
  var LIB = window.CYO_PROFILE_LIBRARY || { tools: [] };
  var LOGO_FULL = [50.9, 358.2, 170.7, 388.7], LOGO_BIRD = [139.9, 358.2, 170.7, 388.6];
  var GROUPS = { standard: 'Standard 3" × 5.75"', xl: 'XL 3" × 8.5"', tile: 'Texture tile 3.5"' };
  function houseTool(id) { return LIB.tools.find(function (t) { return t.id === id; }) || null; }
  function houseSVG(t, color, opts) {
    opts = opts || {};
    var fill = COLORS[color] || color || '#3A3A3A';
    var logoFill = lum(fill) > 0.6 ? 'rgba(0,0,0,.28)' : 'rgba(255,255,255,.4)';
    var logo = '';
    if (!opts.thumb && t.lb) {
      var src = t.group === 'tile' ? LOGO_BIRD : LOGO_FULL, paths = t.group === 'tile' ? T.logo.slice(0, 2) : T.logo;
      var sx = (t.lb[2] - t.lb[0]) / (src[2] - src[0]), sy = (t.lb[3] - t.lb[1]) / (src[3] - src[1]);
      logo = '<g transform="translate(' + t.lb[0] + ' ' + t.lb[1] + ') scale(' + sx.toFixed(3) + ' ' + sy.toFixed(3) + ') translate(' + (-src[0]) + ' ' + (-src[1]) + ')" fill="' + logoFill + '">' +
        paths.map(function (d) { return '<path d="' + d + '"/>'; }).join('') + '</g>';
    }
    return '<svg class="' + (opts.thumb ? 'cyo__thumb-svg' : 'cyo__prof-svg') + '" viewBox="0 0 ' + t.w + ' ' + t.h + '" role="img" aria-label="' + t.name + '">' +
      '<path d="' + t.cut + '" fill="' + fill + '" fill-rule="evenodd"/>' + logo + '</svg>';
  }

  window.CYOProfile = {
    LIB: LIB, GROUPS: GROUPS, houseTool: houseTool, houseSVG: houseSVG,
    T: T, PATTERNS: PATTERNS, COLORS: COLORS, MAX_DEPTH_IN: MAX_DEPTH_IN, MIN_DEPTH_IN: MIN_DEPTH_IN, FOOT_MAX_IN: FOOT_MAX_IN, N_DRAW: N_DRAW,
    defaults: defaults, CUT_SHAPES: CUT_SHAPES, CUT_LIMITS: { minW: CUT_MIN_W, maxW: CUT_MAX_W, minD: CUT_MIN_D, maxD: CUT_MAX_D }, clampCut: clampCut, cutAt: cutAt, yToT: yToT, tidy: tidy, outlineD: outlineD, previewSVG: previewSVG, exportSVG: exportSVG, label: label,
    drawFromPattern: drawFromPattern, smooth: smooth, drawAt: drawAt
  };
})();
